export default {
  es: {
    create: 'Crear nuevo registro',
    textContent:
      'A continuación se muestran los últimos eventos que has reportado:',
    report: 'Reportar',
    formDescription:
      'Ahora completa el registro llenando los siguientes campos cuidadosamente.',
    eventReports: 'Reporte de eventos',
    description: 'Primero, selecciona el tipo de evento que deseas reportar.',
    confirmInfo: 'Tu reporte fue enviado exitósamente',
    comments: 'Comentario (Opcional)',
    date: 'Fecha del evento',
    urgencyLevel: 'Nivel de urgencia',
    attendee: 'Profesional que debe atender',
    professional: 'Profesional',
    edit: 'Editar evento',
    patientEventCreated: 'Un nuevo evento ha sido creado',
    patientEventUpdated: 'Un evento ha sido actualizado',
    patientEventDeleted: 'Un evento ha sido eliminado',
    eventType: 'Tipo de evento',
    Hospitalización: 'Hospitalización',
    'Cambio de Asegurador': 'Cambio de asegurador',
    'Causal de inasistencia': 'Causal de inasistencia',
    'Situacion Familiar': 'Situación familiar',
    'Dificultad de contacto telefónico con la Clinica':
      'Dificultad de contacto telefónico con la clínica',
    'Cambio de Telefono de Contacto': 'Cambio de teléfono de contacto',
    'Cambio de Domicilio': 'Cambio de domicilio'
  },
  en: {
    create: 'Create new record',
    textContent: 'Below are the latest events you have reported:',
    report: 'Report',
    formDescription:
      'Now carefully complete the register filling out the next fields.',
    eventReports: 'Event reports',
    description: 'First, select the event type that you want to report.',
    confirmInfo: 'Your report was sent successfuly',
    comments: 'Comment (Opcional)',
    date: 'Event date',
    urgencyLevel: 'Urgency level',
    attendee: 'Professional who must attend',
    professional: 'Professional',
    edit: 'Edit event',
    patientEventCreated: 'A newevent has been created',
    patientEventUpdated: 'A newevent has been updated',
    patientEventDeleted: 'An event has been deleted',
    eventType: 'Event type',
    Hospitalización: 'Hospitalización',
    'Cambio de Asegurador': 'Cambio de Asegurador',
    'Causal de inasistencia': 'Causal de inasistencia',
    'Situacion Familiar': 'Situacion Familiar',
    'Dificultad de contacto telefónico con la Clinica':
      'Dificultad de contacto telefónico con la Clinica',
    'Cambio de Telefono de Contacto': 'Cambio de Telefono de Contacto',
    'Cambio de Domicilio': 'Cambio de Domicilio'
  }
};
